import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";

//react routing
import {useHistory} from "react-router-dom";

//sweet alert
import swal from "sweetalert";

//types
import {CLOSE_LOGIN_POPUP, SET_USER} from "../store/user/types";

//ant design
import "antd/dist/antd.css";
import {Modal, Button, Form, Input} from "antd";
import {UserOutlined, LockOutlined} from "@ant-design/icons";

//css
import "../css/style.css";

//facebook login
import FacebookLogin from "react-facebook-login";

//google login with firebase
import firebase from "firebase";
import {auth, db} from "../firebase/firebase";

import {Col, Row} from "react-bootstrap";

import $, {error} from "jquery";

//toast
import {alert} from "../util/toast";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [userData, setUserData] = useState({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [loginType, setLoginType] = useState("");
  const [isName, setIsName] = useState(false);
  const [selectRole, setSelectRole] = useState(false);
  const [role, setRole] = useState("");
  const {dialog} = useSelector((state) => state.user);

  const [form] = Form.useForm();

  const responseFacebook = async (response) => {
    const query = await db
      .collection("users")
      .where("fbId", "==", response.id)
      .get();

    let isFbIdExist;
    await query.forEach((item) => {
      isFbIdExist = {...item.data()};
    });

    if (query.docs.length === 0) {
      setIsName(true);
      setName(response.name);
      setUserData({
        _id: Math.floor(100000000000 + Math.random() * 900000000000),
        email: null,
        fbId: response.id,
        name: response.name,
        loginType: "facebook",
        password: null,
      });
    }

    if (query.docs.length === 1) {
      dispatch({type: CLOSE_LOGIN_POPUP});
      dispatch({
        type: SET_USER,
        payload: {_id: isFbIdExist._id, type: isFbIdExist.userType},
      });
      alert("success", "Login Successful!");
      console.log(isFbIdExist);
      localStorage.setItem(
        "Detail",
        JSON.stringify({
          name: isFbIdExist.name,
          email: isFbIdExist.email,
        })
      );

      window.location.href = "/profile";
      history.push("/profile");
    }
    // setPicture(response.picture.data.url);
    // if (response.accessToken) {
    //   setLogin(true);
    // } else {
    //   setLogin(false);
    // }
  };

  const googleProvider = new firebase.auth.GoogleAuthProvider();
  const signInWithGoogle = async () => {
    try {
      const res = await auth.signInWithPopup(googleProvider);
      const user = res.user;

      const query = await db
        .collection("users")
        .where("email", "==", user.email)
        .get();

      let isEmailExist;
      await query.forEach((item) => {
        isEmailExist = {...item.data()};
      });

      if (query.docs.length === 0) {
        setIsName(true);
        setName(user.displayName);
        setUserData({
          _id: Math.floor(100000000000 + Math.random() * 900000000000),
          email: user.email,
          name: user.displayName,
          loginType: "google",
          password: null,
        });
      }

      if (query.docs.length === 1) {
        dispatch({type: CLOSE_LOGIN_POPUP});
        dispatch({
          type: SET_USER,
          payload: {_id: isEmailExist._id, type: isEmailExist.userType},
        });
        alert("success", "Login Successful!");
        console.log(isEmailExist);
        localStorage.setItem(
          "Detail",
          JSON.stringify({
            name: isEmailExist.name,
            email: isEmailExist.email,
          })
        );
        window.location.href = "/profile";
        history.push("/profile");
      }
    } catch (err) {
      console.error(err);
      await swal({
        title: "Error",
        text: err.message,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      name: name,
    });
  }, [name, form]);

  useEffect(() => {
    if (dialog) {
      $(".navbar").addClass("top-zIndex");
    } else {
      $(".navbar").removeClass("top-zIndex");
    }
  }, [dialog]);

  const handleClose = () => {
    dispatch({type: CLOSE_LOGIN_POPUP});
  };

  const handleClick = (id) => {
    setRole(id);
    const previousId = localStorage.getItem("PREVIOUS_ID");
    setUserData({...userData, userType: id});
    $(`#${previousId}`).removeClass("roleBoxActive");
    $(`#${id}`).addClass("roleBoxActive");
    localStorage.setItem("PREVIOUS_ID", id);
  };

  const handleLogin = async () => {
    if (!role) return alert("error", "Please select Your Role");

    await db.collection("users").add({
      _id: userData._id,
      name: userData.name,
      fbId: userData.fbId ? userData.fbId : null,
      email: userData.email,
      userType: userData.userType,
      password: userData.password,
      loginType: userData.loginType,
    });
    dispatch({type: CLOSE_LOGIN_POPUP});
    dispatch({
      type: SET_USER,
      payload: {_id: userData._id, type: userData.userType},
    });
    alert("success", "Login Successful!");
    localStorage.setItem(
      "Detail",
      JSON.stringify({
        name: userData.name,
        email: userData.email,
      })
    );
    window.location.href = "/profile";
    history.push("/profile");
  };
  const manualLoginResponse = async () => {
    debugger;
    console.log(email);
    const query = await db
      .collection("users")
      .where("email", "==", email.trim())
      .get();

    let isEmailExist;
    await query.forEach((item) => {
      isEmailExist = {...item.data()};
    });

    if (isEmailExist) {
      if (isEmailExist.password === null)
        return alert("error", `You are Login with ${isEmailExist.loginType}`);

      if (password !== isEmailExist.password)
        return alert("error", `Password Does not Match!`);
    }

    if (query.docs.length === 0) {
      setIsName(true);
      setName(name);
      setUserData({
        _id: Math.floor(100000000000 + Math.random() * 900000000000),
        email: email.trim(),
        name: name,
        loginType: "manual",
        password: password.trim(),
      });
    }

    if (query.docs.length === 1) {
      dispatch({type: CLOSE_LOGIN_POPUP});
      dispatch({
        type: SET_USER,
        payload: {_id: isEmailExist._id, type: isEmailExist.userType},
      });
      alert("success", "Login Successful!");
      localStorage.setItem(
        "Detail",
        JSON.stringify({
          name: isEmailExist.name,
          email: isEmailExist.email,
        })
      );
      window.location.href = "/profile";
      return setTimeout(() => {
        history.push("/profile");
      }, 3000);
    }
  };

  return (
    <>
      <Modal
        title={selectRole ? "Select Role" : "Login or Signup"}
        centered
        visible={dialog}
        onCancel={handleClose}
        maskClosable={true}
      >
        <Form
          form={form}
          name="normal_login"
          className="login-form"
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          // onFinish={onFinish}
        >
          {isName && (
            <Form.Item
              name="name"
              label="Name"
              initialValue={{
                remember: true,
              }}
              rules={[
                {
                  required: true,
                  message: "Please input your Name!",
                },
              ]}
              requiredMark="optional"
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Name"
                onChange={(e) => {
                  setName(e.target.value);
                  setUserData({...userData, name: e.target.value});
                }}
              />
            </Form.Item>
          )}
          {!isName && !selectRole && (
            <>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Please input your Email!",
                  },
                ]}
                requiredMark="optional"
              >
                <Input
                  type="email"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Email"
                  className="loginInput"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    // setUserData({ ...userData, name: e.target.value });
                  }}
                />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Please input your Password!",
                  },
                ]}
                requiredMark="optional"
              >
                <Input.Password
                  // minLength="6"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password"
                  className="loginInput"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    // setUserData({ ...userData, name: e.target.value });
                  }}
                />
              </Form.Item>
            </>
          )}

          {selectRole && (
            <>
              <Row>
                <Col>
                  <div
                    className="border roleBox text-center my-3"
                    id="interviewer"
                    onClick={() => handleClick("interviewer")}
                  >
                    <img
                      src="/interview.png"
                      height="50"
                      width="50"
                      alt="interviewer"
                    />
                    <h6 className="pt-3">I am Interviewer</h6>
                  </div>
                </Col>
                <Col>
                  <div
                    className="border arrow bottom roleBox text-center my-3"
                    id="interviewee"
                    onClick={() => handleClick("interviewee")}
                  >
                    <img
                      src="/job-interview.png"
                      height="50"
                      width="50"
                      alt="interviewee "
                    />
                    <h6 className="pt-3">I am Interviewee</h6>
                  </div>
                </Col>
              </Row>
            </>
          )}

          <Form.Item>
            {isName && (
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                className="login-form-button mt-2"
                onClick={() => {
                  setSelectRole(true);
                  setIsName(false);
                }}
              >
                Continue
              </Button>
            )}
            {selectRole && (
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                className="login-form-button mt-2"
                onClick={handleLogin}
              >
                Continue
              </Button>
            )}
            {!isName && !selectRole && (
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                className="login-form-button mt-2"
                onClick={manualLoginResponse}
              >
                Agree & Join
              </Button>
            )}
          </Form.Item>

          {!isName && !selectRole && (
            <>
              <p className="line">or</p>
              <Button
                type="primary"
                htmlType="button"
                shape="round"
                className="login-form-button"
                onClick={signInWithGoogle}
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #3b7dcc",
                  color: "#3b7dcc",
                }}
              >
                <img src="/search.png" style={{marginRight: 10}} />
                Join With Google
              </Button>
              <FacebookLogin
                appId="1006751713472340"
                autoLoad={false}
                fields="name,email,picture"
                scope="public_profile,user_friends"
                textButton="join with facebook"
                callback={responseFacebook}
                cssClass="facebook-btn"
                icon={
                  <i
                    class="fab fa-facebook fa-lg"
                    style={{marginRight: 10}}
                  ></i>
                }
              />
            </>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default Login;
